module.exports = __webpack_public_path__ + "static/media/storm_ventures_logo.64a52f51.jpg";